import VueI18n from "vue-i18n";
import Vue from "vue";

Vue.use(VueI18n);
const lang = localStorage.getItem("lang");
const locale = lang == "EN" ? "en-US" : "de-CH";

export default new VueI18n({
    locale,
    messages: {
        "en-US": {
            lang: "EN",
            spannortWelcome: `
            <style>
            table {
                display: table;
            }
            table tr {
                display: table-cell;
                vertical-align: top;
            }
            table tr td {
                display: block;
            }
            </style>
<div style="display: flex; column-gap: 1rem;">
    <div style="width: 100%;">
        <strong>Opening hours</strong>
        <table>
        <tr>
        <td>Monday day off</td>
        <td>Tuesday day off</td>
        <td>Wednesday from 6 p.m.</td>
        <td>Thursday from 6 p.m. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
        <td>Friday from 6 p.m.</td>
        <td>Saturday from 6 p.m.</td>
        <td>Sunday from 3 p.m.</td>
        </tr>
        </table>
        <br/>
        We are looking forward to your reservation&nbsp;by phone<br/>
        +41(0)41 500 11 33 or with the online- tool.<br/><br/>
        <strong>Vacations</strong><br/>
        We’ll be taking a three-week creative break starting October 25, 2026. 
        RESTAURANT SPANNORT will reopen for you on Wednesday, November 18, 2026.
    </div>
</div>
            `,
            restarauntOpening: "Spring menu",
            philosophyText: `Every day we give our very best – when preparing fresh, regional produce in the 
            kitchen and when serving the delicious dishes in the cosy dining area. Our culinary 
            creations, personal charm, and warm hospitality are guaranteed to win over diners’ 
            hearts and stomachs. This truly is service with a smile as we try to ensure our guests 
            feel pampered and cared for. We take pride in creating a relaxing, convivial 
            atmosphere where diners can sit back and enjoy!<br/><br/>
            <h5>The seasonal menu is accompanied by a regularly adapted 5-course menu “our story”</h5>`,
            philosophy: "Philosophy",
            introTitle: "Autumnal treats",
            introText: `A warm welcome to Restaurant Spannort, where things are getting wild and autumnal. Enchant your senses with our creative culinary compositions conjured from fresh, regional produce. With every bite you can see, taste and feel the loving attention to detail that we invest in all our autumn creations. Enjoy the hospitality of our charming and competent team of servers as you settle down to a delicious meal in our cosy restaurant.
<br/><br/>
We are looking forward to spoiling you with unforgettable culinary moments from our autumn menu.`,
            openingHours: `
            <p><strong>Opening hours</strong></p>
            <table>
            <tr>
            <td>Monday day off</td>
            <td>Tuesday day off</td>
            <td>Wednesday from 6 p.m.</td>
            <td>Thursday from 6 p.m. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
            <td>Friday from 6 p.m.</td>
            <td>Saturday from 6 p.m.</td>
            <td>Sunday from 3 p.m.</td>
            </tr>
            </table>
            `,
            team: [
                {
                    name: "Andre Keller",
                    title: "",
                    desc: `
                    The restaurant’s owner is a qualified chef, but in the kitchen his talents as a host were hidden behind the scenes. And so he came to the front of the house, where his witticisms and humour keep the service team and guests well entertained. His enthusiasm as the host of Restaurant Spannort carries over into his private life, where he is a dedicated husband and daddy and a keen snowboarder.`,
                    url: "",
                },
                {
                    name: "Carlos Szentgroti",
                    title: "",
                    desc: `
                    Originally from Hungary, chef Carlos has many years’ experience in Switzerland and abroad. And he loves to share that experience with our guests in the shape of many and varied culinary creations. Carlos isn’t just a dab hand in the kitchen, he is also a family man who enjoys spending time with his loved ones. In his free time, he keeps in shape by pumping iron.`,
                    url: "",
                },
                {
                    name: "Nico Fischer",
                    title: "",
                    desc: `
                    Our sous chef Nico bears a remarkable resemblance to King of Thrones royal rogue Joffrey Baratheon – but he’s much nicer, we promise! Nico is a qualified pâtissier whose desserts are simply to die for! He has set up his own gym at home, and his dream is to buy a swish new car.`,
                    url: "",
                },
                {
                    name: "Peter Szentgroti",
                    title: "",
                    desc: `
                    If you look closely, you might recognize the resemblance to Carlos - because Peter is his brother. While Carlos rocks the hot kitchen, Peter is the master of cool delights. Starters and desserts are his territory.</br>In his free time, he swaps his cooking spoon for running shoes and keeps himself up to date with what's going on in the world.`,
                    url: "",
                },
                // {
                //     name: "Adam",
                //     title: "",
                //     desc: `
                //     Adam completes the Hungarian trio! Newly arrived in Switzerland, he brings fire to the kitchen to the meat and fish. After working with Jamie Oliver in London, he’s now exploring Switzerland, discovering new flavors and the country’s most beautiful places.`,
                //     url: "",
                // },
                // {
                //     name: "Denis",
                //     title: "",
                //     desc: `
                //     Denis takes care of the side dishes as an entremetier. While he has the lentils in front of him in the kitchen, he enjoys standing behind the lens in his free time.As a passionate photographer, he often spends time out in nature.`,
                //     url: "",
                // },
                // {
                //     name: "Anastasiia Yefimenko",
                //     title: "",
                //     desc: `
                //     Anastasiia came to us from Ukraine with great courage and is a valuable support to our service team as an intern. With her friendly nature and warm smile, she quickly wins the hearts of our guests. In her free time, she is especially interested in beauty and city trips - and this summer she will begin her apprenticeship as a hairdresser.`,
                //     url: "",
                // },
                {
                    name: "Elizaveta Meissner",
                    title: "",
                    desc: `
                    Liz brings a breath of fresh air to our service team. With her open personality and great sense for guests, she makes everyone feel welcome. When she's not pulling off spectacular snowboard backflips, she finds her inner calm through yoga and meditation.`,
                    url: "",
                },
                {
                    name: "Joanna Stirnimann",
                    title: "",
                    desc: `
                    Joanna is completing her apprenticeship as a restaurant service professional at RESTAURANT SPANNORT and is discovering the world of hospitality with great enthusiasm. In her free time, she enjoys working out and spending time with her friends. With her open and friendly personality, she is a great addition to our team.`,
                    url: "",
                },
                {
                    name: "Gabriella Andersson",
                    title: "",
                    desc: `
                    Gabriella loves being on the move – downhill biking in summer and freeriding in winter. She also enjoys the finer things in life, from good food and drinks to a few beautiful plants. With her cheerful and open personality, she brings plenty of energy to our team.`,
                    url: "",
                },
                // {
                //     name: "Gian Lippuner",
                //     title: "",
                //     desc: `
                //     With his Schaffhausen dialect, trainee chef Gian has brought fresh wind into our kitchen. No one here pronounces “lime and ginger” quite as charmingly as he does ! Gian travels regularly across half the country between his workplace, his school, and his family home back in Eastern Switzerland. In his free time he loves to get out his mountain bike and head for the hills.`,
                //     url: "",
                // },
            ],
            contactFormResponseError: "An error occured.",
            contactFormResponseSuccess: "Thank you for contacting us.",
        },
        "de-CH": {
            lang: "DE",
            spannortWelcome: `
            <style>
            table {
                display: table;
            }
            table tr {
                display: table-cell;
                vertical-align: top;
            }
            table tr td {
                display: block;
            }
            </style>
<div style="display: flex; column-gap: 1rem;">
    <div style="width: 100%;">
        <strong>Öffnungszeiten</strong>
        <table>
        <tr>
        <td>Montag Ruhetag</td>
        <td>Dienstag Ruhetag</td>
        <td>Mittwoch ab 18.00 Uhr </td>
        <td>Donnerstag ab 18.00 Uhr </td>
        <td>Freitag ab 18.00 Uhr </td>
        <td>Samstag ab 18.00 Uhr </td>
        <td>Sonntag ab 15.00 Uhr </td>
        </tr>
        </table>
        <br/>
        Wir freuen uns auf Ihre Reservation&nbsp;telefonisch unter<br/>
        +41(0)41 500 11 33 oder mit dem Online-Tool.<br/><br/>
        <strong>Betriebsferien</strong><br/>
        Ab dem 25. Oktober 2026 gönnen wir uns eine dreiwöchige Kreativpause. 
        Ab Mittwoch, dem 18. November 2026, ist das RESTAURANT SPANNORT wieder für euch geöffnet.
    </div>
</div>
            `,
            introTitle: "Herbstlicher Genuss",
            introText: `Herzlich willkommen bei uns im RESTAURANT SPANNORT. Es wird wild und herbstlich bei uns! Lassen Sie Ihre Sinne von unseren kreativen Menükompositionen aus frischen und regionalen Produkten begeistern. Mit jedem Bissen fühlen, schmecken und sehen Sie die Liebe zum Detail, die wir in unsere Herbstgerichte legen. Unser aufgewecktes Serviceteam macht mit viel Charme Ihren Besuch in unseren heimeligen Räumlichkeiten zu einem komplett gelungenen Erlebnis.
<br/><br/>
Wir freuen uns darauf, Sie bald bei uns zu begrüssen und Ihnen unvergessliche kulinarische Momente mit unserer Herbstkarte zu bereiten.`,
            restarauntOpening: "Restaurant Eröffnung",
            openingText: `<br>
DANKE…<br>
	…für viele lustige und interessante Zusammentreffen.<br>
	…dass ihr unsere Empfehlungen schätzt und liebt.<br>
	…für eure Treue und euer Vertrauen. <br>

    <br><br>
Wir schauen auf einen geglückten Start zurück und sind sehr dankbar, dass ihr uns an der Dorfstrasse dermassen herzlich empfangen habt. Der DANK geht besonders an unsere Gäste, die uns besucht und somit unterstütz haben, die Geschichte des RESTAURANT SPANNORT weiterzuschreiben. 
<br><br>
Unglaublich, aber wahr, dass wir bereits in kurzer Zeit unzählige Stammgäste kennen dürfen. Ihr macht den SPANNORT zu etwas ganz Besonderem. Wir fühlen uns wertgeschätzt und sehr geehrt, euch bei uns zu empfangen. Auf viele weitere lustige Zusammentreffen mit euch freuen wir uns.
<br><br>
Danke an alle Lieferanten und Produzenten, die mit ihren erstklassigen Produkten die Herzen unserer Gäste miterobert haben und auch weiter erobern werden. 
<br><br>
Ein grosses Dankeschön richten wir an die Familie Kurer für die angenehme Zusammenarbeit und für das Vertrauen, das ihr uns schenkt. 
<br><br>
Wir freuen uns.<br>
Euer SPANNORT Team
            `,
            "About Us": "ÜBER UNS",
            Products: "Produkte",
            Contact: "Kontakt",
            "Contact us": "Kontakt",
            "Book your table here": "Bitte buchen Sie ihren Tisch hier",
            philosophyText: `Wir geben täglich unser Bestes – beim Zubereiten der regionalen und frischen 
            Produkte in der Küche oder beim Anrichten der kreativen Gerichte. Doch nicht nur 
            das Angebot auf dem Teller soll überzeugen, sondern auch die Gastfreundschaft. Wir 
            begrüssen unsere Gäste mit einem herzlichen Lachen und begleiten sie mit viel 
            Charme durch den Abend. In unserem Restaurant finden Sie eine Atmosphäre, in der 
            Sie sich zurücklehnen und geniessen können.<br/><br/>
            <h5>Die saisonale Menükarte wird durch ein regelmässig angepasstes 5- Gänge Menü “unserem G\`schichtli“ begleitet.</h5>`,
            philosophy: "Philosophie",
            openingHours: `
            <p><strong>Öffnungszeiten</strong></p>
            <table>
            <tr>
            <td>Montag Ruhetag</td>
            <td>Dienstag Ruhetag</td>
            <td>Mittwoch ab 18.00 Uhr </td>
            <td>Donnerstag ab 18.00 Uhr </td>
            <td>Freitag ab 18.00 Uhr </td>
            <td>Samstag ab 18.00 Uhr </td>
            <td>Sonntag ab 15.00 Uhr </td>
            </tr>
            </table>
            `,
            WELCOME: "Willkommen",
            "Meet our Team": "Unser Team",
            "Read more": "Weiterlesen",
            team: [
                {
                    name: "Andre Keller",
                    title: "",
                    desc: `
                    Unser Gastgeber wüsste als gelernter Koch auch in der Küche zu überzeugen – aber dort kämen seine Gastgeberqualitäten nicht zum Tragen. Mit seinen Sprüchen und seinem Humor unterhält er Team und Gäste gleichermassen. Denselben Enthusiasmus wie im RESTAURANT SPANNORT legt der Papi auch zu Hause in seinem Frauenhaushalt oder auf dem Snowboard an den Tag.`,
                    url: "",
                },
                {
                    name: "Carlos Szentgroti",
                    title: "",
                    desc: `Der gebürtige Ungar überzeugt seit mehreren Jahren als Küchenchef im In - und Ausland mit seinen leckeren Menükreationen. Doch Carlos ist nicht nur ein Meister am Herd, sondern auch ein Familienmensch, der gerne Zeit mit seinen Liebsten verbringt. Vollen Krafteinsatz gibt er zudem beim Gewichtestemmen in seiner Freizeit.`,
                    url: "",
                },
                {
                    name: "Nico Fischer",
                    title: "",
                    desc: `
                    Steht da King Joffrey aus King of Thrones in der Spannort - Küche? Nein, nicht ganz. Aber unser Sous Chef sieht ihm zum Verwechseln ähnlich! Als ausgebildeter Pâtissier vermag er unsere Gäste statt mit adligem Blut mit seinen Dessertkreationen um den Finger zu wickeln. Nico hat zu H ause ein eigenes Fitnessstudio eingerichtet und träumt von einem neuen Auto.`,
                    url: "",
                },
                {
                    name: "Peter Szentgroti",
                    title: "",
                    desc: `
                    Wer genau hinschaut, erkennt vielleicht die Ähnlichkeit zu Carlos – denn Peter ist sein Bruder. Während Carlos die warme Küche rockt, ist Peter der Meister der kühlen Genüsse. Vorspeisen und Desserts sind sein Revier.</br>In seiner Freizeit tauscht er Kochlöffel gegen Sportschuhe und bleibt immer up to date mit dem, was in der Welt passiert.`,
                    url: "",
                },
                // {
                //     name: "Adam",
                //     title: "",
                //     desc: `
                //     Adam macht das ungarische Trio perfekt! Frisch in der Schweiz angekommen, bringt er Feuer in die Küche und Leidenschaft an Fleisch und Fisch. Nach seiner Zeit bei Jamie Oliver in London zieht er nun durch die Schweiz, immer auf der Suche nach neuen Geschmackserlebnissen und den schönsten Orten.`,
                //     url: "",
                // },
                // {
                //     name: "Denis",
                //     title: "",
                //     desc: `
                //     Denis sorgt als Entremetier für die Beilagen. Während er in der Küche die Linsen vor sich hat, steht er in seiner Freizeit gerne hinter der Linse. Als leidenschaftlicher Fotograf ist er oft in der Natur unterwegs.`,
                //     url: "",
                // },
                // {
                //     name: "Anastasiia Yefimenko",
                //     title: "",
                //     desc: `
                //     Anastasiia ist mit viel Mut aus der Ukraine zu uns gekommen und ist als Praktikantin eine wertvolle Unterstützung für unser Serviceteam. Mit ihrer freundlichen Art und ihrem Lächeln gewinnt sie schnell die Herzen unserer Gäste. In ihrer Freizeit interessiert sie sich besonders für Beauty und Städtereisen - und diesen Sommer startet sie ihre Ausbildung zur Coiffeuse.`,
                //     url: "",
                // },
                {
                    name: "Elizaveta Meissner",
                    title: "",
                    desc: `
                    Liz bringt ordentlich frischen Wind in unser Serviceteam. Mit ihrer offenen Art und ihrem Gespür für Gäste sorgt sie dafür, dass sich jeder willkommen fühlt. Wenn sie nicht gerade spektakuläre Backflips auf dem Snowboard zeigt, findet sie ihre innere Ruhe beim Yoga und Meditieren.`,
                    url: "",
                },
                {
                    name: "Joanna Stirnimann",
                    title: "",
                    desc: `
                    Joanna absolviert bei uns im RESTAURANT SPANNORT ihre Ausbildung zur Restaurationsfachfrau EFZ und entdeckt mit viel Freude die Welt der Gastronomie. In ihrer Freizeit hält sie sich gerne beim Fitness fit und trifft sich mit ihren Kolleginnen und Kollegen. Mit ihrer offenen und freundlichen Art ist sie eine schöne Bereicherung für unser Team.`,
                    url: "",
                },
                {
                    name: "Gabriella Andersson",
                    title: "",
                    desc: `
                    Gabriella ist gerne unterwegs – im Sommer am liebsten beim Downhill-Biken, im Winter beim Freeriden. Dabei dürfen für sie Genussmomente mit gutem Essen und einem feinen Getränk genauso wenig fehlen wie ein paar schöne Pflanzen. Mit ihrer lebensfrohen und offenen Art bringt sie viel Energie in unser Team.`,
                    url: "",
                },
                // {
                //     name: "Gian Lippuner",
                //     title: "",
                //     desc: `
                //     Unser Lernender bringt mit seinem Schaffhauser - Dialekt eine willkommene Abwechslung in unsere Küche: niemand kann so schön «Limetten - Ingwer» sagen wie er. Für seine Kochausbildung in Engelberg pendelt der Ostschweizer für Schule und die freien Tage bei seiner Familie mit dem Zug durch die halbe Schweiz. In seiner Freizeit befindet er sich am liebsten auf dem Mountainbike.`,
                //     url: "",
                // },
            ],
            contactFormResponseError: "Es ist ein Fehler aufgetreten.",
            contactFormResponseSuccess:
                "Danke, dass Sie uns kontaktiert haben.",
            "Send us a message": "Uns eine Nachricht senden",
            "Full name": "Name",
            Company: "Unternehmen",
            "Enter something...": "Gib etwas ein ...",
            Menu: "Menükarte",
            "Food/Drink": "Essen / Trinken",
            Reservations: "Reservationen",
            "Wine list": "Weinkarte",
        },
    },
});
